<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :inputs="inputs"
    :is-form-fetched="isFetched"
    :module-enabler="moduleEnabler"
    :has-buttons="false"
  >
    <template #[`dataAccessRestrictions.input`]>
      <v-row no-gutters>
        <v-col cols="12">
          <data-access-restrictions-settings-list />
        </v-col>
      </v-row>
    </template>
  </admin-wrapper>
</template>
<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import DataAccessRestrictionsSettingsList from '@/components/DataAccessRestrictionsSettingsList';

export default {
  name: 'DataAccessRestrictionsSettings',
  components: { AdminWrapper, DataAccessRestrictionsSettingsList },
  computed: {
    additionalModuleName: get('admin/additionalModules@DATASOURCES_BY_GROUP_MODULE.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@datasources_by_group_module_enabled'),
    inputs() {
      return [
        {
          name: 'dataAccessRestrictions',
          isNamedSlot: false,
        },
      ];
    },
    moduleEnabler() {
      return {
        name: 'datasources_by_group_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle2', { suffix: this.additionalModuleName }),
      };
    },
  },
  data: () => ({
    isFetched: false,
  }),
  methods: {
    getDataSources: call('layers/getLayersMetadata'),
    getDataAccessRestrictions: call('dataAccessRestrictions/getDataAccessRestrictions'),
    getGroups: call('users/getGroups'),
    getAllRelationValuesMapping: call('attributesSchema/getAllRelationValuesMapping'),
    async init() {
      await Promise.all([
        this.getDataAccessRestrictions(),
        this.getDataSources({ with_attributes_schema: true }),
        this.getGroups(),
        this.getAllRelationValuesMapping(),
      ]);
      this.isFetched = true;
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFetched = true;
    }
  },
};
</script>
